import orderBy from 'lodash-es/orderBy';

const sortAlerts = (alerts = []) =>
	orderBy(alerts, [(a) => a.isTradeable, (a) => a.triggered, (a) => a.alertConditionId], ['desc', 'desc', 'desc']);

export default sortAlerts;
